<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">
    <!--
            value: {{ value }} <br/>
            defaultValue: {{ formProperty.defaultValue }}
        -->

    <!-- Popup Window Buttons -->
    <template v-if="isPopupWindowButton()">
      <!--
                  <b>value:</b> {{ value }}<br/>
                  <b>propertyInstanceValue:</b> {{ formatValue.propertyInstanceValue }} <br/>
                  <b>defaultValue:</b> {{ formProperty.defaultValue }}<br/>
                  <b>readOnly:</b> {{ readOnly }}<br/>
                  <b>formProperty.readonly:</b> {{ formProperty.readonly }}
      -->
      <q-btn-group :class="propertyHasError?'text-red-14':(popupWndStyle?'':'text-primary ') + formProperty.cssClass + ' q-mb-md full-width'" outline :style="popupWndStyle">
        <q-btn @click="openPopup" class="col" outline :disable="value==='' || value==null || readOnly || formProperty.readonly" :loading="btnLoading">
          <q-item class="full-width q-ma-none q-pa-none">
            <q-item-section avatar v-if="popupIcon">
              <q-icon :name="popupIcon" size="md"/>
            </q-item-section>
            <q-item-section side>
              <q-item-label class="text-bold">{{ formProperty.title }}</q-item-label>
              <q-item-label caption class="text-left">{{ getHint() }}</q-item-label>
            </q-item-section>
          </q-item>
          <template v-slot:loading>
            <q-spinner-bars class="on-left"/>
            {{ getAutoclickText() ? getAutoclickText() : "Bitte warten..." }}
          </template>
        </q-btn>
        <q-btn class="col-auto" outline @click="deletePopupOiID()" v-if="getPopupDeleteSetting() && (getPopupDeleteSetting()!=='0' || getPopupDeleteSetting()==='false')" :disable="value==='' || value==null || readOnly || formProperty.readonly">
          <q-icon class="text-red-7" name="delete"/>
        </q-btn>
      </q-btn-group>

      <div v-if="propertyHasError" style="margin:-5px 0 10px 15px">
        <small class="text-red-14" v-html="getErrorLabel()"/>
      </div>
    </template>

    <!-- Link Button -->
    <template v-else-if="formProperty.defaultValue && formProperty.defaultValue.startsWith('link://') && !readOnly">
      <q-btn :class="propertyHasError?'text-red-14':'text-primary' + ' ' + formProperty.cssClass + ' q-mb-md full-width text-left'" outline @click="openPopup" :disable="value==='' || value==null">
        <div class="text-left full-width" style="line-height:17px">
          <b class="text-subtitle1 text-bold">{{ formProperty.title }}</b><br/>
          <div class="text-grey-7" style="margin-top:-1px;text-transform:none">{{ getHint() }}</div>
        </div>
      </q-btn>
      <div v-if="propertyHasError" style="margin:-5px 0 10px 15px">
        <small class="text-red-14" v-html="getErrorLabel()"/>
      </div>
    </template>

    <!-- String Textfield Input -->
    <template v-else>
      <q-input v-if="!formProperty.readonly && !readOnly" :label="getTitle()" @update:model-value="onChange" :debounce="volatile?0:500" :prefix="formProperty.titlePrefix" :suffix="formProperty.titleSuffix"
               :hint="getHint()" :placeholder="formProperty.infoTextHint" :readonly="readOnly" @keydown.enter="onEnter" :type="(formProperty.cssClass && formProperty.cssClass.includes('password')) ? 'password' : 'text'"
               :maxlength="formProperty.lengthMax" bottom-slots v-model="value" :autofocus="formProperty.autofocus" :autogrow="isMemo()"
               :input-style="isMemo()?'min-height:60px':''" :clearable="true" :filled="true" counter :class="formProperty.cssClass"
               :error="propertyHasError" :error-message="getErrorLabel()" :dense="volatile || compressed"
               :id="formProperty.nativename" :ref="formProperty.nativename">
        <template #append v-if="formProperty.ocrType>0">
          <q-btn color="primary" dense flat :icon="formProperty.ocrType === 1 ? 'ion-barcode' : 'ion-qr-scanner'" @click.stop.prevent="showOCRDlg()"/>
        </template>
      </q-input>

      <!-- Readonly representation -->
      <q-field v-if="formProperty.readonly || readOnly" :readonly="true" :label="getTitle()" stack-label :dense="volatile || compressed" borderless filled :error="propertyHasError" :hint="getHint()"
               :error-message="formProperty.errorMsg" bg-color="grey-1" :class="formProperty.cssClass + ' txtMemoField'" style="white-space: preserve">
        <template v-slot:control>
          <div v-html="formatValue()"/>
        </template>
      </q-field>

    </template>
  </div>
</template>
<script>
import {getValueOrCleanNull} from './formsHelper'
import OcrComp from '../tech/ocr-comp'
import {StreamBarcodeReader} from "vue-barcode-reader";
import useVuelidate from '@vuelidate/core'
import {maxLength, minLength, requiredIf} from '@vuelidate/validators'
import {QrcodeCapture, QrcodeDropZone, QrcodeStream} from 'vue3-qrcode-reader'

import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from '../../classes/StaticData'
import {setCssVar} from 'quasar'
import {useAuthStore} from 'src/stores/AuthStore.js'
import URLHelper from "src/classes/URLHelper";

export default {
  mixins: [fldComponentsMixin],
  props: [
    'queryID',
    'formProperty',
    'volatile',
    'compressed',
    'readOnly',
    'actionReadonly'
  ],
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
    OcrComp,
    StreamBarcodeReader
  },
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      StaticData,
      value: null,
      qrOpen: false,
      ocrInitLoading: false,
      cssClass: "css" + this.formProperty.nativename,
      pendingSelfRefresh: false,
      popupWndStyle: null,
      popupIcon: null,
      btnLoading: false,
      autoclickInterval: null
    }
  },

  computed: {
    propertyHasError() {
      return (this.v$.value.$error && !this.v$.$errors.map(err => err.$validator).includes('requiredIf')) || this.formProperty.invalid
    }
  },

  validations() {
    return this.getValidations()
  },

  watch: {
    value: function () {
      this.formProperty.value = getValueOrCleanNull(this.value, this.formProperty)
    },
    formProperty: {
      handler: function (newVal) {
        this.value = newVal.value
      },
      deep: false
    }
  },

  methods: {
    showOCRDlg() {
      this.$emit('useOCRScanDialog', {
        formProperty: this.formProperty
      })
    },

    isPopupWindowButton() {
      let result = false
      let val = this.formProperty.defaultValue
      if (this.isPopupWindowString(val) && !this.readOnly) result = true
      if (!result) {
        if (this.value && this.isPopupWindowString(this.value)) result = true
      }
      /*
            if (this.formProperty.nativename === "btnArticleWarrenty") {
              console.log("isPopupWindowButton - defaultValue:" + this.formProperty.defaultValue)
              console.log("isPopupWindowButton - value:" + this.value)
              console.log("isPopupWindowButton - result:" + result)
            }
      */
      return result
    },

    getPopupWindowStyle() {
      let val = this.formProperty.defaultValue ? this.formProperty.defaultValue : this.value
      return URLHelper.getParamValue(val, "style")
      // console.log("getPopupWindowStyle:", this.formProperty.title, result)
    },

    getPopupDeleteSetting() {
      let val = this.formProperty.defaultValue ? this.formProperty.defaultValue : this.value
      // console.log("getPopupDeleteSetting:", this.formProperty.title, ":", URLHelper.getParamValue(val, "delete"))
      return URLHelper.getParamValue(val, "delete")
    },

    getPopupIcon() {
      let val = this.formProperty.defaultValue ? this.formProperty.defaultValue : this.value
      return URLHelper.getParamValue(val, "icon")
      // console.log("getPopupWindowStyle:", this.formProperty.title, result)
    },

    getAutoclick() {
      let val = this.formProperty.defaultValue ? this.formProperty.defaultValue : this.value
      return URLHelper.getParamValue(val, "autoclick")
    },

    getAutoclickText() {
      let val = this.formProperty.defaultValue ? this.formProperty.defaultValue : this.value
      return URLHelper.getParamValue(val, "autoclicktext")
    },

    isPopupWindowString(str) {
      return (str && typeof str === "string" && (str.includes('formular://') || str.includes('cat://') || str.includes('query://') || str.includes('link://') || str.includes('qrcode://')))
    },

    deletePopupOiID() {
      this.$q.dialog({
        title: "Formular wirklich löschen?",
        ok: this.$t('yes'),
        cancel: this.$t('no'),
        style: "width:50%",
      }).onOk(() => {
        let deleteSetting = this.getPopupDeleteSetting()
        console.log("delete setting:", deleteSetting)
        // delete button is visible, cause setting '&delete' is present
        // if delete = 1|true or 0|false - the value of the field is set to null
        // if delete is something else - it is treated as the nativename of button which will bei emitted (can then be a query:// with ac=acDelete
        if (deleteSetting) {
          if (deleteSetting === "1" || deleteSetting === "true") {
            this.value = this.formProperty.defaultValue
            this.popupWndStyle = this.getPopupWindowStyle()
          } else {
            // emit event to open popup
            this.eventBus.clickFrmTitleButton(deleteSetting) // open query:// with action for delete selected key

            let val = this.value
            let popupMap = URLHelper.getParamValue(val, "map")
            let popupRefresh = URLHelper.getParamValue(val, "refresh")

            if (popupMap) {
              let popupFieldMap = popupMap.split(";")

              // refresh mapped oiID of parent formular
              for (let i = 0; i < popupFieldMap.length; i++) {
                let mapfield = popupFieldMap[i]
                let f = mapfield.split("|")

                // map oiID:parentfield -> parentfield gets value of objectinstance
                if (f[0] === "oiID") {
                  for (let y = 0; y < this.formProperty.parentForm.length; y++) {
                    let form = this.formProperty.parentForm[y]

                    for (let z = 0; z < form.formularFields.formularFlatList.length; z++) {
                      let field = form.formularFields.formularFlatList[z]
                      if (field.nativename === f[1]) {
                        console.log("mapFormFieldsBackToParent: oiID Emit onChange for mapping field:", field.nativename, ", value:", field.value, field)
                        this.eventBus.setPropertyValue(field.id, "-")
                        this.eventBus.changeFormularField(form.id, field, "-", true)
                        break
                      }
                    }
                  }
                }
              }
            }

            if (popupRefresh) {
              console.log("*** popupDeleteRefresh ", this.formProperty.title, ":", popupRefresh, this.value)
              let popupFieldMap = popupRefresh.split(";")
              console.log("*** popupFieldMap ", this.formProperty.title, ":", popupFieldMap)

              // refresh mapped oiID of parent formular
              for (let i = 0; i < popupFieldMap.length; i++) {
                let refreshfield = popupFieldMap[i]

                // map oiID:parentfield -> parentfield gets value of objectinstance
                for (let y = 0; y < this.formProperty.parentForm.length; y++) {
                  let form = this.formProperty.parentForm[y]

                  for (let z = 0; z < form.formularFields.formularFlatList.length; z++) {
                    let field = form.formularFields.formularFlatList[z]
                    if (field.nativename === refreshfield) {
                      console.log("refresh after delete: ", field.nativename, ", value:", field.value, field)
                      //this.eventBus.setPropertyValue(field.id, "")
                      this.eventBus.changeFormularField(form.id, field, field.value, false)
                      break
                    }
                  }
                }
              }
            }
          }
        }
      }).onCancel(() => {
      })
    },

    formatValue() {
      let idx = 0
      let value = this.value

      // if we have a SQL error after fetchingData - there is no output of the value
      //console.log("this.formProperty.errorFetchingData: ", this.formProperty.errorFetchingData);

      if (this.formProperty.errorFetchingData && this.formProperty.errorFetchingData !== "") {
        value = ""
        console.error("Had errorFetchingData (", this.formProperty.errorFetchingData, "). Set value of ", this.formProperty.title, " to ''")
      } else if (value && typeof value === "string") {
        while ((idx = value.indexOf("gsm://")) > -1) {
          let telNr = ""
          let telIdx = idx + 6
          while ((!isNaN(parseInt(value.charAt(telIdx))) || value.charAt(telIdx) === ' ' || value.charAt(telIdx) === '/') && telIdx < value.length) {
            telNr += value.charAt(telIdx)
            telIdx++
          }
          value = value.replace("gsm://" + telNr, "<a href='tel:" + telNr + "'>" + telNr + "</a>")
        }

        if (this.formProperty.datatypeID === StaticData.DATATYPES.TYPE_LINK) {
          value = "<a href='" + value + "' target='_blank'>" + value + "</a>"
        }

        if (this.formProperty.datatypeID <= 5) {  // int,Long,Int64
          value = parseFloat(value).toLocaleString('de-DE', {})
        }
      }
      if (this.value === "null") value = ""
      return value;
    },

    onChange(value) {
      this.formProperty.invalid = false
      this.v$.$touch()
      this.value = value
      this.formProperty.value = value
      this.setErrorBrandColor()

      // todo: only in formulars
      // send onChange event to parent (formular or parameter)
      // if (this.formProperty.nativename == "vh_id") console.log("fldString - onChange explizit", this.value, this.formProperty.value)

      this.$emit('onChange', {classID: this.formProperty.classID, nativename: this.formProperty.nativename, deleteDependentFields: true, value: this.value})

      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }
    },

    onEnter(value) {
      if (this.volatile) {
        // this.formProperty.value = this.value
        //console.log("emit onEnter, ", this.value, this.formProperty.value)
        this.$emit('onEnter')  // submit volatile parameters for immediate refresh
      }
    },

    onRefreshComp(data) {
      if (this.formProperty.nativename === data.nativename && (data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount)) {
        let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''

        // this component instance is a dependent field of changed field?
        if (myDepToken.includes(data.sourceChangedNativename) ||
          ((data.sourceChangedNativename === this.formProperty.nativename) && this.formProperty.ocrType > 0)) { // && !this.isPopupWindowString(data.value)

          //if (data.nativename === "propStrichcodeScan") console.log("2")

          //console.log("string data.sourceChangedNativename:", this.formProperty.title, ", ", data.sourceChangedNativename, "==", myDepToken, ", value:", data.value)
          //console.log("!!! onRefreshComp of ", this.formProperty.title + " triggered.", this.formProperty.nativename, data.value, data.value.length)
          this.value = data.value
          this.formProperty.value = data.value

          if (this.isPopupWindowString(data.value)) {
            this.formProperty.readonly = false
            this.formProperty.defaultValue = data.value

          } else {
            this.formProperty.defaultValue = data.defaultValue
            if (this.formProperty.dataTypeID === StaticData.DATATYPES.TYPE_STATIC_TEXT) {
              this.formProperty.readonly = true
            }
          }

          if (data.errorMsg) this.formProperty.errorMsg = data.errorMsg
          else this.formProperty.errorMsg = ""
          if (data.errorFetchingData) this.formProperty.errorFetchingData = data.errorFetchingData
          else this.formProperty.errorFetchingData = ""

          if (data.errorMsg || data.errorFetchingData) this.formProperty.invalid = true
          else this.formProperty.invalid = false

          if (this.isPopupWindowButton()) {
            this.popupWndStyle = this.getPopupWindowStyle()
            this.popupIcon = this.getPopupIcon()
          }
          this.$forceUpdate()

          this.initAutoclick()

          if (this.formProperty.instantRefresh &&
            (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {

            if (this.formProperty.nativename == "propStrichcodeScan") console.log("fldString - onRefresh - onchange for ", this.formProperty.nativename, this.value)
            //console.log("cascade onChange ongoing from ", this.frmProperty.title)

            this.$emit('onChange', {
              classID: this.formProperty.classID,
              id: this.formProperty.ID,
              nativename: this.formProperty.nativename,
              deleteDependentFields: true,
              value: this.value,
              sourceChangedNativename: data.sourceChangedNativename
            })  // send onChange event to parent (formular or parameter)

          } else {
            this.showSpinner = false
          }
        }
        //}
      }
    },

    getValidations() {
      let result = {value: {}}
      if (this.formProperty.dataTypeID !== StaticData.DATATYPES.TYPE_STATIC_TEXT && !this.formProperty.readonly) {
        if (!this.formProperty.lengthMin) this.formProperty.lengthMin = 0
        result.value['minLength'] = minLength(this.formProperty.lengthMin)
        result.value['maxLength'] = maxLength(this.formProperty.lengthMax)
        result.value['requiredIf'] = requiredIf(() => {
          if (this.formProperty.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
            return (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) && this.formProperty.showThroughDependency === true
          } else {
            return this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY
          }
        })
        result.value['isValidGen'] = (value) => {  // generell invalid flag (triggered from extern)
          return !this.formProperty.invalid
        }
        result.value['isPatternMatch'] = (value) => {
          if (this.formProperty.regularExpression && value != null) {
            let re = new RegExp(this.formProperty.regularExpression)
            if (re.test(value)) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        }
      }
      return result
    },

    getErrorLabel() {
      let result = ""
      const errors = this.v$.$errors.map(err => err.$validator)
      if (errors.includes("requiredIf")) {
        result = this.formProperty.infoRequired && this.formProperty.infoRequired !== "" ? this.formProperty.infoRequired : "Feld muss befüllt werden."

      } else if (errors.includes("minLength")) {
        const min = this.v$.$errors.find(err => err.$validator === "minLength").$params.min
        result = "Ungültige Länge, min: " + min

      } else if (errors.includes("maxLength")) {
        const max = this.v$.$errors.find(err => err.$validator === "maxLength").$params.max
        result = "Ungültige Länge, max: " + max

      } else if (errors.includes("isPatternMatch")) {
        result = "Ungültige Eingabe" // Benötigtes Format: " + this.formProperty.regularExpression

      } else {
        result = this.formProperty.errorMsg
      }
      //console.log("errorLabel: ", result)
      return result
    }
    ,

    // get current value of this string field
    // priority: 1-query parameter (deep link call), 2-local storage, 3-value, 4-default value
    getValue() {
      const authStore = useAuthStore()
      let result = this.value ? this.value : this.formProperty.propertyInstanceValue // native value
      let propertyName = this.formProperty.name ? this.formProperty.name : this.formProperty.nativename
      let storedValue = localStorage.getItem(this.queryID + "__" + propertyName)
      let deepLinkParamValue = authStore.queryParamListFromDeepLink[this.formProperty.nativename]

      if (deepLinkParamValue) {
        // parameter value, given as request parameter (e.g.: qp.name), set in store in router beforeEach
        result = deepLinkParamValue

      } else if (storedValue != null && !this.formProperty.systemParameter) {
        // use stored value in localstorage
        result = storedValue

      } else if (!this.formProperty.propertyInstanceValue && this.formProperty.defaultValue) {
        // use defaultValue of field
        result = this.formProperty.defaultValue
      }

      this.value = result
      this.formProperty.value = result

      return result
    },

    isMemo() {
      return this.formProperty.dataTypeID === StaticData.DATATYPES.TYPE_MEMO
    },

    onClear(pevent) {
      if ((this.formProperty.nativename === pevent.nativename || pevent.nativename === "*") && (pevent.subtypeCount === undefined || pevent.subtypeCount === this.formProperty.subtypeCount)) {
        //console.log("fldString - event onClearValueList: ", this.formProperty.nativename, ", resetValue:", pevent.resetValue)

        let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''
        //console.log("onClearValueList with nativename ", this.formProperty.title, pevent.nativename, myDepToken, pevent.sourceChangedNativename, this.formProperty.valuelistType,this.formProperty.dataTypeID )
        //console.log("onClearValueList:", this.formProperty.title, '(', this.formProperty.nativename, ') ', pevent.sourceChangedNativename, ', refreshToken=', this.refreshToken, '!=', pevent.guid)

        // this component instance is a dependent field of changed field? - clear this component instance an cascade the clear.
        if (myDepToken.includes(pevent.sourceChangedNativename)) {
          if (!this.isPopupWindowString(this.formProperty.defaultValue)) {
            this.value = ""
            this.formProperty.value = ""
            // cascade clear event to other valuelists which are perhaps dependent on this
            // this.eventBus.clearValueListComp("*", "", this.formProperty.nativename, pevent.guid)
          }
        }
      }
    },

    onSetPropertyValue(data) {
      if (this.formProperty.id === data.formPropertyID) {
        // console.log("------------ set value of " + this.formProperty.title + " to " + data.value)
        //this.formProperty.propertyInstanceValue = data.value
        this.value = data.value
        this.formProperty.value = data.value
      }
    }
    ,

    setErrorBrandColor() {
      try {
        if (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) {
          setCssVar('negative', '#F57C00', document.getElementById('cont_' + this.formProperty.nativename))
        } else {
          setCssVar('negative', '#C10015', document.getElementById('cont_' + this.formProperty.nativename))
        }
      } catch (e) {
      }
    },

    onAutocompleteApplyButton(data) {
      if (this.formProperty.nativename === data.nativename && (data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount)) {
        this.value = data.value
        this.formProperty.value = data.value
        this.formProperty.errorMsg = ""
        this.formProperty.errorFetchingData = ""
        this.formProperty.invalid = false
        this.$forceUpdate()

        if (this.formProperty.instantRefresh && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          this.$emit('onChange', {
            classID: this.formProperty.classID,
            id: this.formProperty.ID,
            nativename: this.formProperty.nativename, deleteDependentFields: true, value: this.value
          })  // send onChange event to parent (formular or parameter)
        } else {
          this.showSpinner = false
        }
      }
    },

    openPopup() {
      //console.log("fldString - openPopupWindow", this.formProperty)
      this.$q.loading.show()
      let val = this.formProperty.defaultValue ? this.formProperty.defaultValue : this.value
      let commitParentObjClassID = URLHelper.getParamValue(val, "commitparent")
      if (commitParentObjClassID) {
        this.eventBus.formularApply(commitParentObjClassID, this.formProperty)
      } else {
        this.eventBus.openPopup(this.formProperty)
      }
    },

    onClickFrmTitleButton(btnNativenameToClick) {
      if (this.formProperty.nativename === btnNativenameToClick) {
        //console.log("onClickFrmTitleButton - ", btnNativenameToClick, this.formProperty)
        //console.log("this.formProperty.propertyInstanceValue - ", this.formProperty.propertyInstanceValue)

        if (this.formProperty.value && this.isPopupWindowString(this.formProperty.value)) {
          this.openPopup()

        } else if (this.formProperty.value && this.formProperty.value.startsWith('<a ')) {
          this.executeLink(this.formProperty.value)

        } else {
          this.$q.dialog({
            title: "Keine Daten vorhanden",
            message: "Für diese Anlage sind keine Daten vorhanden",
            ok: this.$t('ok'),
            style: "width:70%",
            html: true

          }).onOk(() => {
          })
        }
      }
    },

    executeLink(myLink) {
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = myLink;
      let tempAnchor = tempDiv.querySelector('a');

      if (tempAnchor && tempAnchor.href.startsWith('javascript:')) {
        let jsCode = tempAnchor.href.slice('javascript:'.length)
        console.log("executeLink - ", jsCode)
        eval(jsCode)

      } else if (tempAnchor) {
        console.log("executeLink - ", tempAnchor.href)
        tempAnchor.click()
      }
    },

    initAutoclick() {

      this.$nextTick(() => {
        let autoclick = this.getAutoclick()

        if (autoclick && !this.autoclickInterval && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          console.log("initAutoclick ... START. ", autoclick, this.formProperty.showThroughDependency, this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)
          this.btnLoading = true

          this.autoclickInterval = setInterval(() => {
            let endCondition;
            try {
              endCondition = eval(this.getAutoclick())
              console.log("Rückgabewert:", endCondition)

              if (endCondition === true || endCondition == null) {
                console.log("initAutoclick - endCondition")
                this.btnLoading = false
                clearInterval(this.autoclickInterval)
                this.autoclickInterval = null

              } else {
                this.openPopup()
              }

            } catch (error) {
              console.error("Error initAutoclick:", error)
            }
          }, 5000)
        }
      });
    },
  },

  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
    this.eventBus.off('onClearValueList', this.onClear)
    this.eventBus.off('onAutocompleteApplyButton', this.onAutocompleteApplyButton)
    this.eventBus.off('onSetPropertyValue', this.onSetPropertyValue)
    this.eventBus.off('onClickFrmTitleButton', this.onClickFrmTitleButton)
  },

  mounted: function () {
    /*
     if (this.formProperty.defaultValue && this.formProperty.defaultValue.startsWith("query:")) {
     console.log("BEFORE getVAlue:", this.value)
     console.log("mount this.value:", this.value)
     console.log("mount this.formProperty.value:", this.formProperty.value)
     console.log("mount this.defaultValue:", this.formProperty.defaultValue)
     console.log("-----------------------------------------")
     }
     */

    this.value = this.getValue()
    if (this.isPopupWindowButton()) {
      this.popupWndStyle = this.getPopupWindowStyle()
      this.popupIcon = this.getPopupIcon()
    }

    // set default validation values if nothing is set (e.g. resulset field update - no length can be set)
    if (!this.formProperty.lengthMin) this.formProperty.lengthMin = 0
    if (!this.formProperty.lengthMax) this.formProperty.lengthMax = 100

    this.eventBus.on('onRefreshComp', this.onRefreshComp)
    this.eventBus.on('onClearValueList', this.onClear)
    this.eventBus.on('onAutocompleteApplyButton', this.onAutocompleteApplyButton)
    this.eventBus.on('onSetPropertyValue', this.onSetPropertyValue)
    this.eventBus.on('onClickFrmTitleButton', this.onClickFrmTitleButton)

    this.initAutoclick()

    this.formProperty.validate = () => {
      this.v$.$reset()
      this.v$.$touch()
      this.formProperty.invalid = this.v$.value.$error
      this.formProperty.errorMsg = this.getErrorLabel()
      this.setErrorBrandColor()

      if (this.formProperty.errorFetchingData !== "") {
        this.formProperty.errorMsg = this.formProperty.errorFetchingData
        this.formProperty.invalid = true
      }
      //console.log("validate ", this.formProperty.title, ", errorMsg:", this.formProperty.errorMsg, ", invalid:", this.formProperty.invalid, this.formProperty)
    }

    this.formProperty.setValid = () => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
      this.v$.$reset()
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
      this.v$.$touch()
    }

    // Initial error? This can be if the field has SQL enabled content...
    if (this.formProperty.errorFetchingData && this.formProperty.errorFetchingData !== "") {
      this.formProperty.setError(this.formProperty.errorFetchingData)
    }

    // send onChange event to parent (formular or parameter)
    if (this.formProperty.dataTypeID !== StaticData.DATATYPES.TYPE_STATIC_TEXT && !this.formProperty.noInitOnChange && !this.formProperty.objInstanceID) {
      this.$emit('onChange', {classID: this.formProperty.classID, nativename: this.formProperty.nativename, deleteDependentFields: false, value: this.value})
    }
  }
}
</script>

<style lang="sass">
.txtMemoField .q-field__native
  padding-top: 5px !important
</style>
